export const sleep = (ms = 0) => {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

/** UUID Generator - compatível com diferentes ambientes */
export const generateUUID = (): string => {
  // Verifica se crypto.randomUUID está disponível (Node.js 16+ ou navegadores modernos)
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID()
  }

  // Fallback para ambientes que não suportam crypto.randomUUID
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

/** Validation */
export const validators = {
  email: (v: string) => {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return pattern.test(v) || 'Digite um e-mail válido'
  },
  required: (v: any) => !!v || 'Campo obrigatório',
}

export const stripInvalidId = (data: any) => {
  if (data === null || data === undefined) return data
  if (typeof FormData !== 'undefined' && data instanceof FormData) return data
  if (typeof URLSearchParams !== 'undefined' && data instanceof URLSearchParams) return data
  if (typeof Blob !== 'undefined' && data instanceof Blob) return data
  if (typeof File !== 'undefined' && data instanceof File) return data
  if (typeof data !== 'object' || Array.isArray(data)) return data
  const payload: any = { ...data }
  if ('id' in payload) {
    const idValue = payload.id
    const numericId = typeof idValue === 'number' ? idValue : typeof idValue === 'string' ? Number(idValue) : null
    if (idValue == null || idValue === '' || (numericId != null && !Number.isNaN(numericId) && numericId <= 0)) {
      delete payload.id
    }
  }
  return payload
}

export const stripId = (data: any) => {
  // Remove only the top-level `id` (nested relationship ids must remain).
  if (data === null || data === undefined) return data
  if (typeof FormData !== 'undefined' && data instanceof FormData) return data
  if (typeof URLSearchParams !== 'undefined' && data instanceof URLSearchParams) return data
  if (typeof Blob !== 'undefined' && data instanceof Blob) return data
  if (typeof File !== 'undefined' && data instanceof File) return data
  if (typeof data !== 'object' || Array.isArray(data)) return data
  const payload: any = { ...data }
  if ('id' in payload) {
    delete payload.id
  }
  return payload
}

const coerceFirstErrorMessage = (value: unknown): string | null => {
  if (!value) return null

  if (typeof value === 'string') return value

  if (Array.isArray(value)) {
    for (const item of value) {
      const message = coerceFirstErrorMessage(item)
      if (message) return message
    }
    return null
  }

  if (typeof value === 'object') {
    for (const item of Object.values(value as Record<string, unknown>)) {
      const message = coerceFirstErrorMessage(item)
      if (message) return message
    }
  }

  return null
}

export const getApiErrorMessage = (error: any, fallback = 'Erro na requisição'): string => {
  const data = error?.response?.data

  const preferred =
    data?.error || data?.detail || data?.message || coerceFirstErrorMessage(data) || error?.message || fallback

  return typeof preferred === 'string' ? preferred : fallback
}
